import { IMaskInput } from 'react-imask';
import { styled } from '@mui/material/styles';

export const locationPanel = {
  '&.MuiBox-root': {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 40px 20px',
    '@media only screen and (max-width: 600px)': {
      padding: '8px',
    },
  },
} as const;

export const collapsedPanelStyle = {
  '&.MuiPaper-elevation1': {
    '&.MuiCard-root': {
      backgroundColor: 'panel.light',
      boxShadow: 'none',
      border: 'none',
      padding: '8px',
    },
  },
} as const;

export const openPanelStyle = {
  boxShadow: `0px 4px 20px -8px rgba(0, 0, 0, 0.3) !important`,
  marginTop: '16px',
  backgroundColor: 'panel.light',
  marginBottom: '8px',

  '--Paper-overlay': 'unset !important',
  '&.MuiPaper-elevation1': {
    '& .MuiButton-root': {
      padding: '8px 16px',
      borderRadius: '18px',
    },
  },
} as const;

export const StyledIMaskInput = styled(IMaskInput, {
  shouldForwardProp: (prop) => prop !== 'hasError',
})((_: { hasError?: boolean } & React.HTMLProps<HTMLInputElement>) => {
  return {
    padding: '9px',
    borderRadius: '4px',

    marginTop: '-1px',

    '&:focus': {
      marginTop: '-2px',
      outline: 'none',
    },
  };
});

export const getMaskedStyles = (hasError: boolean) => ({
  width: '100%',
  backgroundColor: 'transparent',
  color: 'text.main',
  border: `1px solid white`,
  borderColor: hasError ? 'error.main' : 'text.subdued',

  '&:focus': {
    border: `2px solid white`,
    borderColor: hasError ? 'error.main' : 'secondary.main',
  },
});
